<div class="dialog">
  <div class="dialog-header">
    <h4 mat-dialog-title>
      <mat-icon>directions_boat</mat-icon>
      {{ 'dredging_title' | translate }}
    </h4>
    <button type="button" class="close-button" (click)="onNoClick()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <form #form="ngForm">
    <div class="equipment-name-section">
      <div class="form-field">
        <label class="form-label">
          <mat-icon class="label-icon">directions_boat</mat-icon>
          {{ 'dredging_label_equipment_name' | translate }}
        </label>
        <input type="text" class="form-input" [placeholder]="'dredging_placeholder_equipment_name' | translate" [(ngModel)]="data.displayName" name="name" required cdkFocusInitial />
      </div>
    </div>

    <mat-accordion multi="true">
      <mat-expansion-panel [(expanded)]="openMobilization" class="mobilization-panel">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon>waves</mat-icon>
            {{ 'dredging_phase_mobilization' | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="panel-content">
          <mat-expansion-panel [(expanded)]="openMobilizationComment" class="comment-panel">
            <mat-expansion-panel-header>
              <mat-panel-title class="comment-title"> {{ 'dredging_label_comment' | translate }} </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="form-field">
              <textarea class="form-textarea" [placeholder]="'dredging_placeholder_comment' | translate" [(ngModel)]="data.bringPhaseComment" name="mobilizationComment" rows="2"></textarea>
            </div>
          </mat-expansion-panel>

          <div class="inputs-grid">
            <div class="form-field">
              <label class="form-label">{{ 'dredging_label_mgo_consumption' | translate }}</label>
              <input type="number" class="form-input" [placeholder]="'dredging_placeholder_mgo_consumption' | translate" [(ngModel)]="data.bringPhaseFuelConsumption" name="mobilizationFuel" min="0" required />
            </div>

            <div class="emissions-display">
              <div class="emissions-label">{{ 'dredging_emissions_mobilization' | translate }}</div>
              <div class="emissions-value">{{ calculateMobilizationEmissions() | localizedNumber: '1.3-3' }} <span class="unit">tCO2eq</span></div>
            </div>
          </div>

          <div class="emission-factor-info">
            <p [innerHTML]="'dredging_emission_factor_note' | translate: { factor: formatEmissionFactor(), fuel: fuelName }"></p>
          </div>

          <mat-card class="info-card">
            <mat-card-content>
              <mat-icon>info</mat-icon>
              <p>{{ 'dredging_info_card_mobilization' | translate }}</p>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel [(expanded)]="openExecution" class="execution-panel">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon>calculate</mat-icon>
            {{ 'dredging_phase_execution' | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="panel-content">
          <mat-expansion-panel [(expanded)]="openExecutionComment" class="comment-panel">
            <mat-expansion-panel-header>
              <mat-panel-title class="comment-title"> {{ 'dredging_label_comment' | translate }} </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="form-field">
              <textarea class="form-textarea" [placeholder]="'dredging_placeholder_comment' | translate" [(ngModel)]="data.execPhaseComment" name="executionComment" rows="2"></textarea>
            </div>
          </mat-expansion-panel>

          <div class="inputs-grid">
            <div class="form-field">
              <label class="form-label">{{ 'dredging_label_execution_duration' | translate }}</label>
              <input type="number" class="form-input" [placeholder]="'dredging_placeholder_execution_duration' | translate" [(ngModel)]="data.execPhaseDuration" name="executionDuration" min="0" required />
            </div>

            <div class="form-field">
              <label class="form-label">{{ 'dredging_label_weekly_mgo' | translate }}</label>
              <input type="number" class="form-input" [placeholder]="'dredging_placeholder_weekly_mgo' | translate" [(ngModel)]="data.execPhaseFuelConsumption" name="weeklyFuel" min="0" required />
            </div>
          </div>

          <div class="emissions-display execution-emissions">
            <div class="emissions-label">
              <mat-icon>calculate</mat-icon>
              {{ 'dredging_emissions_execution' | translate }}
            </div>
            <div class="emissions-value">{{ calculateExecutionEmissions() | localizedNumber: '1.3-3' }} <span class="unit">tCO2eq</span></div>
          </div>

          <mat-card class="info-card blue">
            <mat-card-content>
              <mat-icon>info</mat-icon>
              <p>{{ 'dredging_info_card_execution' | translate }}</p>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-expansion-panel>
    </mat-accordion>

    <div class="upload-section">
      <input type="file" #fileInput (change)="onFileSelected($event)" style="display: none" />
      <button type="button" mat-stroked-button color="accent" (click)="fileInput.click()">
        <mat-icon>upload</mat-icon>
        {{ 'dredging_add_justificatif' | translate }}
      </button>

      <div class="justificatifs-list">
        <mat-chip-list *ngIf="data.fileName">
          <mat-chip [removable]="true" (removed)="removeJustificatif()">
            <mat-icon matChipAvatar>description</mat-icon>
            {{ data.fileName }}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
        </mat-chip-list>
      </div>
    </div>

    <div class="total-section">
      <div class="total-header">
        <mat-icon>calculate</mat-icon>
        <h3>{{ 'dredging_total' | translate }}</h3>
      </div>
      <div class="total-grid">
        <div class="total-item">
          <div class="total-label">{{ 'dredging_total_mgo' | translate }}</div>
          <div class="total-value">{{ getTotalFuelConsumption() | localizedNumber: '1.0-0' }} <span class="unit">L</span></div>
        </div>
        <div class="total-item">
          <div class="total-label">{{ 'dredging_total_emissions' | translate }}</div>
          <div class="total-value highlight">{{ getTotalEmissions() | localizedNumber: '1.3-3' }} <span class="unit">tCO2eq</span></div>
        </div>
      </div>
    </div>

    <mat-expansion-panel [(expanded)]="openEmissionFactors" class="emission-factors-panel">
      <mat-expansion-panel-header>
        <mat-panel-title> {{ 'dredging_emission_factors_title' | translate }} </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="panel-content">
        <p class="info-text">{{ 'dredging_emission_factors_description' | translate }}</p>

        <table mat-table [dataSource]="[{ fuel: fuelName, co2eq: '3.26089' }]" class="emission-table">
          <ng-container matColumnDef="fuel">
            <th mat-header-cell *matHeaderCellDef>{{ 'dredging_col_fuel' | translate }}</th>
            <td mat-cell *matCellDef="let element">{{ element.fuel }}</td>
          </ng-container>

          <ng-container matColumnDef="co2eq">
            <th mat-header-cell *matHeaderCellDef>{{ 'dredging_col_co2eq' | translate }}</th>
            <td mat-cell *matCellDef="let element">{{ element.co2eq }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="['fuel', 'co2eq']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['fuel', 'co2eq']"></tr>
        </table>

        <div class="density-info">
          <p>
            <strong>{{ 'dredging_density_mgo' | translate }}</strong> <span class="mono">0.9 kg/L</span>
          </p>
          <p>
            <strong>{{ 'dredging_emission_factor_label' | translate }}</strong> <span class="mono">{{ formatEmissionFactor() }} tCO2eq/L</span>
          </p>
        </div>
      </div>
    </mat-expansion-panel>
  </form>

  <div mat-dialog-actions>
    <button type="button" mat-button (click)="onNoClick()">{{ 'dredging_btn_cancel' | translate }}</button>
    <button mat-button (click)="onSave()" color="accent" [disabled]="!form.valid">{{ 'dredging_btn_save' | translate }}</button>
  </div>
</div>
